import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    locale: localStorage.getItem('locale') || 'zh-CN'
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_LOCALE(state, locale) {
      state.locale = locale
      localStorage.setItem('locale', locale)
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setUserInfo({ commit }, info) {
      commit('SET_USER_INFO', info)
    },
    setLocale({ commit }, locale) {
      commit('SET_LOCALE', locale)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    locale: state => state.locale
  }
})
